import type {Texto} from '../i18n/idioma';
import type {OpcionDeFiltro} from './opciones-de-filtro';
import {SelectorMultiple} from './selector-multiple';

// Filtro del seguimiento con el conteo de cada opcion. Es acumulable
// (decision 0018): se marcan uno o varios valores.
export function SelectorDeFiltro({
  etiqueta,
  valor,
  opciones,
  onCambiar,
  ayuda,
}: {
  etiqueta: string;
  valor: string | undefined;
  opciones: OpcionDeFiltro[];
  onCambiar: (valor: string | undefined) => void;
  ayuda?: Texto | string;
}) {
  return <SelectorMultiple etiqueta={etiqueta} valor={valor} opciones={opciones} onCambiar={onCambiar} ayuda={ayuda} />;
}
